import { render, staticRenderFns } from "./debtsStats.vue?vue&type=template&id=735ed191&"
import script from "./debtsStats.vue?vue&type=script&lang=js&"
export * from "./debtsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports